module.exports = __webpack_public_path__ + "img/202506_05.a5ed2621.jpg";